export default __webpack_public_path__ + "static/media/cp_geo_al.e955cd23.svg";